/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateIlsDto } from '../../models/create-ils-dto';
import { Ils } from '../../models/ils';

export interface FolderControllerCreateIlsAndAddToFolder$Params {
  folderId: string;
      body: CreateIlsDto
}

export function folderControllerCreateIlsAndAddToFolder(http: HttpClient, rootUrl: string, params: FolderControllerCreateIlsAndAddToFolder$Params, context?: HttpContext): Observable<StrictHttpResponse<Ils>> {
  const rb = new RequestBuilder(rootUrl, folderControllerCreateIlsAndAddToFolder.PATH, 'post');
  if (params) {
    rb.path('folderId', params.folderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Ils>;
    })
  );
}

folderControllerCreateIlsAndAddToFolder.PATH = '/folder/ils/{folderId}';
